import React, {useContext, useEffect, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import queryString from 'query-string';
import {SpinnerButton} from 'common/SpinnerButton';
import {InputWithError} from 'common/InputWithError';
import {finishRegistration} from 'utils/api';
import {AuthContext} from 'contexts/AuthContext';
import {AuthLayout} from "./AuthLayout";

export const ConfirmRegistration = () => {
    const navigate = useNavigate();
    const queryParams = useLocation();
    const {signIn} = useContext(AuthContext);

    const [submitting, setSubmitting] = useState(false);
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [errors, setErrors] = useState(null);

    useEffect(() => {
        setErrors(null);
    }, [password, confirmPassword]);

    const onSubmit = async () => {
        setSubmitting(true);

        try {
            const parsedQuery = queryString.parse(queryParams.search);

            const params = {
                confirmation_token: parsedQuery.token,
                password: password,
                confirm_password: confirmPassword,
            };

            const res = await finishRegistration(params);

            signIn(res?.dpb_token);
            navigate('/');
        } catch (err) {
            setErrors({errors: {'plainPassword': [{'message': err?.detail || err}]}});
        }

        setSubmitting(false);
    };

    const completeRegistrationForm = () => {
        return (
            <div className="d-flex justify-content-center align-items-center flex-grow-1">
                <div className="text-center w-100 px-3 px-md-5">
                    <div className="login-box shadow-sm">
                        <h4 className="mb-5 login-title">Complete Registration</h4>
                        <div className="mb-3 text-start">
                            <label htmlFor="password" className="form-label">Password (Min 6 Characters)</label>
                            <InputWithError
                                id="password"
                                name="password"
                                value={password}
                                type="password"
                                onChange={setPassword}
                                errorObj={errors}
                                autoComplete="off"
                                marginBottomClass="mb-3"
                                className="rounded-pill"
                            />
                        </div>
                        <div className="mb-3 text-start">
                            <label htmlFor="confirm-password" className="form-label">Confirm Password</label>
                            <InputWithError
                                id="confirm-password"
                                name="plainPassword"
                                value={confirmPassword}
                                type="password"
                                onChange={setConfirmPassword}
                                errorObj={errors}
                                autoComplete="off"
                                marginBottomClass="mb-5"
                                className="rounded-pill"
                            />
                        </div>
                        <div className="d-grid mb-4">
                            <SpinnerButton
                                color="primary"
                                block
                                disabled={password.length < 5 && confirmPassword.length < 5}
                                onClick={onSubmit}
                                submitting={submitting}
                                title="Create Account"
                                className="text-bold rounded-pill"
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return <AuthLayout authForm={completeRegistrationForm()}/>
};
